/** Gets the link to the campaign analytics page */
export const getAnalyticsLink = (
  campaignId: number,
  dateParams: {
    startDateString?: string;
    endDateString?: string;
  } = {},
) => {
  const { startDateString, endDateString } = dateParams;
  const startTime = startDateString ? `&startTime=${startDateString}` : '';
  const endTime = endDateString ? `&endTime=${endDateString}` : '';

  return `/analytics/campaignPerformance?campaignId=${campaignId}${startTime}${endTime}`;
};
